// extracted by mini-css-extract-plugin
export default {"event-location":"EventLocation_event-location__RPD92","event-location__link":"EventLocation_event-location__link__1+SZH"};